import React from 'react'

const TermsAndConditions = () => {
  return (
    <p className="text-sm">
      By providing your card or bank information, you are representing that you
      are authorized to use this card or bank account for payments for rental
      deposits, rental payments, or any other services or transactions for
      services provided Company or its affiliate. If you are making a one-time
      payment, your card or bank information will not be stored after completion
      of the transaction, but any other personal information provided in
      connection with the transaction will be stored. If you are enrolling in
      recurring payments, you authorize Company’s electronic payment vendor,
      AdYen, to store your card or bank information to process your recurring
      payments. To access AdYen’s terms and conditions, please visit:
      <a
        className="link link-primary ml-2"
        href="https://www.adyen.com/legal/terms-and-conditions"
        target="_blank"
      >
        https://www.adyen.com/legal/terms-and-conditions
      </a>
      . You are responsible for keeping your card or bank information up to
      date. If your card or bank information changes, you agree to promptly
      update your information. Company will continue to store your card or bank
      information until you delete your information or you cancel recurring
      payments. For more information about how we store and use your card, bank
      or other personal information, please see our Privacy Policy.
    </p>
  )
}

export default TermsAndConditions
